<template>
  <a-tabs default-active-key="1">
    <a-tab-pane key="1">
      <span slot="tab">
        <a-icon type="user"/>
        Información del contrato
      </span>
      <a-row :gutter="[16,16]">
        <a-col :md="24" :xs="24">
          <a-card>
            <a-spin :spinning="loading">
              <a-table
                v-bind="tbConfig"
                rowKey="id_emp"
                :data-source="employeecv"
                :columns="columns">
                <span slot="estado" slot-scope="text">
                  <div v-if="text == 'ACTIVO'">
                  <a-badge status="success"/>ACTIVO
                </div>
                <div v-if="text == 'INACTIVO'">
                  <a-badge color="red"/>INACTIVO
                </div>
                </span>
                <div
                  slot="filterDropdown"
                  slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                  style="padding: 8px"
                >
                  <a-input
                    v-ant-ref="c => (searchInput = c)"
                    :placeholder="`Search ${column.dataIndex}`"
                    :value="selectedKeys[0]"
                    style="width: 188px; margin-bottom: 8px; display: block;"
                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                  />
                  <a-button
                    type="primary"
                    icon="search"
                    size="small"
                    style="width: 90px; margin-right: 8px"
                    @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                  >
                    Search
                  </a-button>
                  <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                    Reset
                  </a-button>
                </div>
                <a-icon
                  slot="filterIcon"
                  slot-scope="filtered"
                  type="search"
                  :style="{ color: filtered ? '#108ee9' : undefined }"
                />
                <template slot="customRender" slot-scope="text, record, index, column">
                    <span v-if="searchText && searchedColumn === column.dataIndex">
                      <template
                        v-for="(fragment, i) in text
                          .toString()
                          .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
                      >
                        <mark
                          v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                          :key="i"
                          class="highlight"
                        >{{ fragment }}</mark
                        >
                        <template v-else>{{ fragment }}</template>
                      </template>
                    </span>
                  <template v-else>
                    {{ text }}
                  </template>
                </template>
              </a-table>
            </a-spin>
          </a-card>
        </a-col>
      </a-row>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadProfileData()
    },
    data () {
      return {
        employeecv: [],
        colConfig: {
          sm: 24,
          md: 24
        },
        colSpan: {
          sm: 24,
          md: 12
        },
        tbConfig: {
          scroll: {x: 'max-content'},
          bordered: true,
          size: 'small',
          pagination: {
            pageSize: 5,
            current: 1,
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40'],
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
          }
        },
        selectedRowKeys: [],
        loadingParent: false,
        loading: false,
        searchText: '',
        searchInput: null,
        searchedColumn: '',
        pagination: {
          pageSize: 5,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '30', '40'],
          showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
        },
        columns: [
          {
            title: 'ID empleado',
            dataIndex: 'id_emp',
            key: 'id_emp',
            width: 200,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.id_emp
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Nombre completo',
            dataIndex: 'nombrecompleto',
            key: 'nombrecompleto',
            width: 220,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.nombrecompleto
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Compañía',
            dataIndex: 'company',
            key: 'company',
            width: 200,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.address
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Fecha inicio del contrato',
            dataIndex: 'fecha_inicio',
            key: 'fecha_inicio',
            width: 230,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.fecha_inicio
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Fecha fin del contrato',
            dataIndex: 'fecha_fin',
            key: 'fecha_fin',
            width: 220,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.fecha_fin
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Estado',
            dataIndex: 'estado',
            width: 150,
            key: 'estado',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => a.estado.length - b.estado.length,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'estado'
            },
            onFilter: (value, record) =>
              record.estado
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          }
        ]
      }
    },
    methods: {
      searchPersonChange (action) {
        if (JsUtils.isEmpty(action)) {
          this.isVisibleDatosPersonales = false
          this.employeecv = []
        } else {
          this.isVisibleDatosPersonales = true
        }
      },
      handleSearch (selectedKeys, confirm, dataIndex) {
        confirm()
        this.searchText = selectedKeys[0]
        this.searchedColumn = dataIndex
      },
      handleReset (clearFilters) {
        clearFilters()
        this.searchText = ''
      },
      loadProfileData () {
        this.loading = true
        this.loadingParent = true
        this.httpClient.getInstance().get('employee/consultar_empleado/' + this.persona)
          .then(response => {
            this.employeecv = response.data.employeecv
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar los datos')
          })
          .then(() => {
            this.selectedRowKeys = []
            this.loading = false
            this.loadingParent = false
          })
      }
    },
    props: ['persona']
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataCliente.vue